var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgress2Line = function SvgProgress2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 12a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0m13.5 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0M17 12a4.49 4.49 0 0 1-1.318 3.182L12.5 12V7.5A4.5 4.5 0 0 1 17 12"
  })));
};
export default SvgProgress2Line;